export default "query GetUser {\n  getUser {\n    username\n    email\n    id\n    groupId\n    role\n    createdAt\n  }\n}"